'use client';

import { useEffect } from 'react';
import { initStorage } from '@/utils/storage/simpleStorage';

/**
 * Simple Storage Initializer
 * Just initializes IndexedDB without any localStorage dependencies
 */
export default function SimpleStorageInitializer() {
  useEffect(() => {
    const init = async () => {
      try {
        if (typeof window !== 'undefined') {
          console.log('Initializing simple IndexedDB storage');
          await initStorage();
        }
      } catch (error) {
        console.error('Error in SimpleStorageInitializer:', error);
      }
    };
    
    init();
  }, []);
  
  return null;
}
